import { ReactNode, useId } from 'react';
import styled from 'styled-components';

import Tooltip from '@paradigm/design-system/src/components/Tooltip';

interface Props {
  readonly children: ReactNode;
  readonly tooltip: string;
  readonly id?: string;
}

export function LongText({ children, tooltip, id }: Props) {
  // useId() returns colon-wrapped strings (e.g. ":r0:") which break
  // reactstrap's popover target lookup (invalid CSS selector).
  const generatedId = useId().replace(/:/gu, '');
  return (
    <Tooltip
      id={id ?? `long-text-${generatedId}`}
      tooltipContent={<TooltipContent>{tooltip}</TooltipContent>}
      placement="bottom-start"
      showIconInPopover={false}
    >
      <Container>{children}</Container>
    </Tooltip>
  );
}

const Container = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const TooltipContent = styled.div`
  max-width: 420px;
  white-space: normal;
  word-break: break-word;
`;
